// Schemes a mail client can open. An allowlist, because "word:" alone also
// matches host:port (example.com:8080) and user:pass@host, and a digit after
// the colon is legitimate for geo:, facetime: or sip:.
const KNOWN_SCHEME =
	/^(https?|ftp|mailto|tel|sms|facetime|callto|fax|geo|sip|sips|maps|whatsapp|skype|zoommtg|msteams):/i;
// Any scheme followed by "//" (webcal://, tg://, itms-apps://). host:port and
// user:pass@host never contain "://", so this cannot reintroduce that mistake.
const HIERARCHICAL_SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

// Relative forms, anchors, protocol-relative and merge tags are left for the
// renderer (Navbar base-url, the send pipeline) to complete.
const PASS_THROUGH = /^(\/|\.\/|\.\.\/|\?|#|\{\{)/;

// A bare address, with no URL syntax (/ ? = : #) around the @.
const LOOKS_LIKE_EMAIL = /^[^\s@/?=:#]+@[^\s@/?=:#]+\.[^\s@/?=:#]+$/;

/**
 * A link address typed without a scheme (`backatyou.com`) is a relative URL to
 * a mail client, so the sending domain gets prepended and the click 404s
 * (monday 13291045384). Make it absolute: `https://` for a host, `mailto:` for
 * an address. Everything that already has a destination passes through.
 */
export function normalizeLinkHref(href: unknown): string {
	if (typeof href !== 'string') return '';
	const value = href.trim();
	if (!value) return '';
	if (PASS_THROUGH.test(value)) return value;
	if (KNOWN_SCHEME.test(value) || HIERARCHICAL_SCHEME.test(value)) return value;
	if (LOOKS_LIKE_EMAIL.test(value)) return `mailto:${value}`;
	return `https://${value}`;
}

const ANCHOR_HREF = /(<a\b[^>]*?\shref=)(["'])([^"']*)\2/gi;

/**
 * Same rule for the anchors inside a rich-text block's HTML, so a link saved
 * before this fix is corrected at render time rather than only when the Link
 * dialog's Apply runs again.
 */
export function normalizeLinkHrefsInHtml(html: string): string {
	if (typeof html !== 'string' || !html.includes('href=')) return html;
	return html.replace(ANCHOR_HREF, (_match, prefix, quote, value) => {
		const normalized = normalizeLinkHref(value);
		return `${prefix}${quote}${normalized || value}${quote}`;
	});
}
